// PGCET MCA Mock 1 — Mathematics (questions 1–30)
const pgcetmcaMathematics = [
  {
    id: 1,
    question: "If x + 1/x = 3, then the value of x³ + 1/x³ is",
    options: ["A. 24", "B. 18", "C. 27", "D. 21"],
    answer: "B"
  },
  {
    id: 2,
    question: "The equation kx² − 6x + 1 = 0 (k ≠ 0) has real roots if and only if",
    options: ["A. k ≤ 9", "B. k ≥ 9", "C. k < 9", "D. k ≤ 3"],
    answer: "A"
  },
  {
    id: 3,
    question: "If α and β are the roots of the equation x² − 5x + 3 = 0, then the value of α³ + β³ is",
    options: ["A. 110", "B. 125", "C. 80", "D. 95"],
    answer: "C"
  },
  {
    id: 4,
    question: "If logₓ 64 = 3/2, then x equals",
    options: ["A. 8", "B. 4", "C. 32", "D. 16"],
    answer: "D"
  },
  {
    id: 5,
    question: "If 3ˣ⁺² − 3ˣ = 216, then the value of x is",
    options: ["A. 3", "B. 2", "C. 4", "D. 6"],
    answer: "A"
  },
  {
    id: 6,
    question: "The positive square root of 11 + 6√2 is",
    options: ["A. √3 + 2√2", "B. 3 + √2", "C. 2 + 3√2", "D. 1 + 3√2"],
    answer: "B"
  },
  {
    id: 7,
    question: "The 7th term of an arithmetic progression is 34 and its 13th term is 64. The 20th term of the progression is",
    options: ["A. 99", "B. 104", "C. 94", "D. 109"],
    answer: "A"
  },
  {
    id: 8,
    question: "The sum of the first n terms of an arithmetic progression is 3n² + 2n. The 10th term of the progression is",
    options: ["A. 65", "B. 320", "C. 59", "D. 53"],
    answer: "C"
  },
  {
    id: 9,
    question: "The sum of an infinite geometric progression is 15 and the sum of the squares of its terms is 45. The common ratio of the progression is",
    options: ["A. 1/3", "B. 3/5", "C. 1/2", "D. 2/3"],
    answer: "D"
  },
  {
    id: 10,
    question: "The 5th term of the harmonic progression 1/2, 1/5, 1/8, … is",
    options: ["A. 1/11", "B. 1/14", "C. 1/17", "D. 1/20"],
    answer: "B"
  },
  {
    id: 11,
    question: "The arithmetic mean of two positive numbers is 9 and their harmonic mean is 4. Their geometric mean is",
    options: ["A. 6", "B. 6.5", "C. √13", "D. 5"],
    answer: "A"
  },
  {
    id: 12,
    question: "The number of terms in the expansion of (1 + 2x + x²)¹⁰ is",
    options: ["A. 11", "B. 20", "C. 30", "D. 21"],
    answer: "D"
  },
  {
    id: 13,
    question: "If the sum of the binomial coefficients in the expansion of (1 + x)ⁿ is 256, then the greatest binomial coefficient in the expansion is",
    options: ["A. 56", "B. 70", "C. 128", "D. 35"],
    answer: "B"
  },
  {
    id: 14,
    question: "The value of (√2 + 1)⁶ + (√2 − 1)⁶ is",
    options: ["A. 198", "B. 99", "C. 140√2", "D. 196"],
    answer: "A"
  },
  {
    id: 15,
    question: "The number of distinct arrangements of the letters of the word BANANA is",
    options: ["A. 120", "B. 720", "C. 60", "D. 360"],
    answer: "C"
  },
  {
    id: 16,
    question: "How many 3-digit even numbers with all digits distinct can be formed using the digits 0, 1, 2, 3, 4, 5?",
    options: ["A. 60", "B. 52", "C. 48", "D. 40"],
    answer: "B"
  },
  {
    id: 17,
    question: "A committee of 5 is to be chosen from 6 men and 4 women so that it contains at least 3 women. The number of ways of forming the committee is",
    options: ["A. 60", "B. 70", "C. 56", "D. 66"],
    answer: "D"
  },
  {
    id: 18,
    question: "In a survey of 100 students, 50 study Mathematics, 40 study Physics and 30 study Chemistry; 15 study Mathematics and Physics, 12 study Physics and Chemistry, 10 study Mathematics and Chemistry, and 5 study all three. The number of students who study none of the three subjects is",
    options: ["A. 12", "B. 18", "C. 8", "D. 15"],
    answer: "A"
  },
  {
    id: 19,
    question: "If n(U) = 50, n(A) = 20, n(B) = 25 and n(A ∩ B) = 8, where U is the universal set, then n(A′ ∩ B′) equals",
    options: ["A. 5", "B. 17", "C. 13", "D. 37"],
    answer: "C"
  },
  {
    id: 20,
    question: "The domain of the real function f(x) = 1/√(x² − 5x + 6) is",
    options: ["A. (2, 3)", "B. [2, 3]", "C. (−∞, 2) ∪ (3, ∞)", "D. (−∞, 2] ∪ [3, ∞)"],
    answer: "C"
  },
  {
    id: 21,
    question: "If f(x) = x² + 1 and g(x) = 2x − 3, then (f∘g)(x) equals",
    options: ["A. 2x² − 1", "B. 4x² − 12x + 10", "C. 4x² + 10", "D. 4x² − 12x + 8"],
    answer: "B"
  },
  {
    id: 22,
    question: "If f : R → (−3, ∞) is defined by f(x) = 2ˣ⁺¹ − 3, then f⁻¹(29) equals",
    options: ["A. 5", "B. 32", "C. 3", "D. 4"],
    answer: "D"
  },
  {
    id: 23,
    question: "If A = [[1, 2], [3, 4]] and B = [[2, 0], [1, −1]], then the product AB is",
    options: ["A. [[4, −2], [10, −4]]", "B. [[2, 4], [−2, −2]]", "C. [[4, 2], [10, 4]]", "D. [[2, 0], [3, −4]]"],
    answer: "A"
  },
  {
    id: 24,
    question: "If the matrix [[0, 2, −3], [x, 0, 4], [3, y, 0]] is skew-symmetric, then x + y equals",
    options: ["A. 6", "B. −6", "C. 2", "D. −2"],
    answer: "B"
  },
  {
    id: 25,
    question: "The rank of the matrix [[1, 1, 2], [2, 3, 5], [3, 4, 7]] is",
    options: ["A. 0", "B. 1", "C. 2", "D. 3"],
    answer: "C"
  },
  {
    id: 26,
    question: "If A = [[4, 7], [1, 2]], then the entry in the first row and second column of A⁻¹ is",
    options: ["A. 7", "B. −1", "C. 4", "D. −7"],
    answer: "D"
  },
  {
    id: 27,
    question: "The value of the determinant |[x + y, y + z, z + x], [z, x, y], [1, 1, 1]]| is",
    options: ["A. x + y + z", "B. 0", "C. xyz", "D. 2(x + y + z)"],
    answer: "B"
  },
  {
    id: 28,
    question: "The area of the triangle with vertices (2, −6), (5, 4) and (k, 4) is 35 square units. The value(s) of k is/are",
    options: ["A. 12 or −2", "B. −12 or 2", "C. 12 only", "D. 2 or 7"],
    answer: "A"
  },
  {
    id: 29,
    question: "For the Boolean variables A = 1, B = 0 and C = 1, the value of the expression A′B + AB′C + (A + B)′ is",
    options: ["A. 0", "B. A′", "C. 1", "D. B"],
    answer: "C"
  },
  {
    id: 30,
    question: "The dual of the Boolean expression A + B·C is",
    options: ["A. A′ + B′·C′", "B. (A + B)·C", "C. A·B + C", "D. A·(B + C)"],
    answer: "D"
  }
];

export default pgcetmcaMathematics;
